import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useCallback, useState, } from 'react';
import { EmployeeApi } from '../api/baseApis';
import { msalInstance } from '../auth';
import { CloseDialogButton } from '../components/CloseDialogButton';
import { useUser } from '../hooks';
export function DeleteConfirmationDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { userDelete } = useUser(EmployeeApi);
    const [confirmText, setConfirmText] = useState('');
    const [doesConfirmTextMatch, setDoesConfirmTextMatch] = useState(null);
    const deleteText = 'DELETE';
    const onConfirmTextChange = (event) => {
        setConfirmText(event.target.value.trim());
        if (event.target.value === deleteText) {
            setDoesConfirmTextMatch(true);
        }
    };
    const handleClose = useCallback(() => {
        setConfirmText('');
        setDoesConfirmTextMatch(true);
        props.setShowDialog(false);
    }, [props]);
    const onDeleteSuccess = () => {
        localStorage.clear();
        sessionStorage.clear();
        msalInstance.logoutRedirect();
    };
    const handleDelete = useCallback(async () => {
        if (confirmText !== deleteText) {
            setDoesConfirmTextMatch(false);
            return;
        }
        await userDelete().mutationAsync(onDeleteSuccess);
        setDoesConfirmTextMatch(true);
    }, [userDelete, confirmText]);
    return (_jsxs(Dialog, { fullScreen: fullScreen, open: props.showDialog, onClose: handleClose, "aria-labelledby": "delete-account-title", children: [_jsx(DialogTitle, { id: "delete-account-title", children: 'Are you sure you want to delete your account?' }), _jsx(CloseDialogButton, { onClose: handleClose }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: _jsx(Typography, { variant: "body1", children: "Type \"DELETE\" to verify your intent to permanently remove your account and all associated data from our system. Be advised that this action is irreversible." }) }) }), _jsx(DialogActions, { children: _jsxs(Grid, { container: true, spacing: 6, alignItems: "center", justifyContent: "center", children: [_jsx(Grid, { item: true, xs: 11.5, children: _jsx(TextField, { label: 'Enter "DELETE" to confirm', required: true, fullWidth: true, error: doesConfirmTextMatch !== null && !doesConfirmTextMatch, helperText: doesConfirmTextMatch !== null &&
                                    !doesConfirmTextMatch &&
                                    'Please type "DELETE" in uppercase if you wish to delete your account', value: confirmText, onChange: onConfirmTextChange }) }), _jsxs(Grid, { item: true, xs: 12, display: 'flex', justifyContent: 'space-between', children: [_jsx(Button, { size: "small", onClick: handleClose, children: "Cancel" }), _jsx(LoadingButton, { variant: "contained", color: "error", size: "small", onClick: handleDelete, loading: userDelete().isLoading, children: "Confirm" })] })] }) })] }));
}
